import * as React from 'react';

interface DaysOfTheWeek {
    colorClass: string;
}

const daysOfTheWeek: React.SFC<DaysOfTheWeek> = (props) => {
    return (
        <div className={`cal-nav-weekdays ${props.colorClass}`}>
            <div className="cal-nav-weekdays-inner">
                <p>Sunday</p>
                <p>Monday</p>
                <p>Tuesday</p>
                <p>Wednesday</p>
                <p>Thursday</p>
                <p>Friday</p>
                <p>Saturday</p>
            </div>
        </div>
    );
}

export default daysOfTheWeek;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/days-of-the-week.tsx